import { createSlice } from '@reduxjs/toolkit';
import { HttpMethod, sendError_notify } from '../../../Asset/httpMethod';
import { startLoader, stopLoader } from '../Utility/loaderSlice';
import { AlertPopup } from "../../../Asset/common";

export const fetchData = (data, RecordPerPage) => async (dispatch) => {

  if (!data) return;

  data.PageNo = [1];
  dispatch(startLoader());

  try {
    debugger
    const res = await HttpMethod.post('/Stock/StockSearch/AsyncStockList', data);
    if (res?.status === 200) {
      dispatch(resetCombinedData());
      dispatch(setFirstData(res?.data));

      const stockList = res?.data?.StockList1 || [];
      const pcs = stockList[0]?.I_PCS;

      if (pcs) {
        const pages = Math.ceil(pcs / RecordPerPage);
        Array.from({ length: pages - 1 }, (_, index) => {
          dispatch(fetchNextData({ ...data, PageNo: [index + 2] }));
        });
      }
    }
  } catch (error) {
    console.error("Error Fetching Data: ", error);
  } finally {
    if (data?.PageNo[0] === 1) {
      dispatch(stopLoader())
    }
  }
};

export const setEmpty = () => (dispatch) => {
  dispatch(resetCombinedData({}));
};

export const fetchNextData = (data) => async (dispatch) => {
  const res = await HttpMethod.post('/Stock/StockSearch/StockList', data);
  if (res?.status === 200) {
    dispatch(appendApiData(await res.data));
  }
};

export const StoneSearchSlice = createSlice({
  name: 'StoneSearch',
  initialState: {},
  loading: false,
  reducers: {
    setFirstData: (state, action) => {
      state.StockList = action.payload.StockList;
      state.StockList1 = action.payload.StockList1;
      return state;
    },
    appendApiData: (state, action) => {

      state.StockList = Array.from(
        new Set([...state.StockList, ...action.payload.StockList].map(JSON.stringify))
      ).map(JSON.parse);

      // state.StockList = [...state.StockList, ...action.payload.StockList];
      state.StockList1 = action.payload.StockList1;
      return state;
    },
    resetCombinedData: (state) => {
      state.StockList = [];
      return state;
    },
  },
});

export const { setFirstData, appendApiData, resetCombinedData } = StoneSearchSlice.actions;
export default StoneSearchSlice.reducer;